<template lang="html">
  <div class="container">
    <div class="row">
      <router-link to="/products"  class="col-md-6 p-2">
        <img class="shadow w-100 rounded instruction-image" src="/images/banners/banner_1.jpg" alt="">
      </router-link>
      <router-link to="/products"  class="col-md-6 p-2">
        <img class="shadow w-100 rounded instruction-image" src="/images/banners/banner_2.jpg" alt="">
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
.instruction-image{
  opacity: .9
}
.instruction-image:hover{
  opacity: 1
}
</style>
